export const ASSISTANT_BRIDGE_METHODS = Object.freeze([
    "state",
    "subscribe",
    "getViewModel",
    "setVisibility",
    "toggleSettings",
    "startNewChat",
    "toggleTaskHistory",
    "refreshTaskHistory",
    "resumeHistory",
    "setMode",
    "setDialect",
    "duplicatePlcProfile",
    "editPlcProfile",
    "deletePlcProfile",
    "focusPlcProfileField",
    "cancelPlcProfileEdit",
    "savePlcProfileEdit",
    "updatePlcProfileDraft",
    "submitComposer",
    "runAction",
    "handleAction",
    "clearHistory",
    "copyResult",
    "exportFlowContext",
    "exportGenerationIr",
    "setQuestionDraftInput",
    "submitQuestionDraft",
    "toggleWorklog"
]);

export function listMissingAssistantBridgeMethods(bridge) {
    return ASSISTANT_BRIDGE_METHODS.filter((name) => {
        if (name === "state") return bridge == null || typeof bridge !== "object" || !("state" in bridge);
        return typeof bridge?.[name] !== "function";
    });
}

export function isAssistantBridge(bridge) {
    return listMissingAssistantBridgeMethods(bridge).length === 0;
}

export function createAssistantBridge(bindings) {
    return {
        state: bindings.state,
        subscribe(listener) {
            if (typeof listener !== "function") return () => {};
            return bindings.subscribe(listener);
        },
        getViewModel: bindings.getViewModel,
        setVisibility: bindings.setVisibility,
        toggleSettings: bindings.toggleSettings,
        startNewChat: bindings.startNewChat,
        toggleTaskHistory: bindings.toggleTaskHistory,
        refreshTaskHistory: bindings.refreshTaskHistory,
        resumeHistory: bindings.resumeHistory,
        setMode: bindings.setMode,
        setDialect: bindings.setDialect,
        duplicatePlcProfile: bindings.duplicatePlcProfile,
        editPlcProfile: bindings.editPlcProfile,
        deletePlcProfile: bindings.deletePlcProfile,
        focusPlcProfileField: bindings.focusPlcProfileField,
        cancelPlcProfileEdit: bindings.cancelPlcProfileEdit,
        savePlcProfileEdit: bindings.savePlcProfileEdit,
        updatePlcProfileDraft: bindings.updatePlcProfileDraft,
        submitComposer: bindings.submitComposer,
        runAction: bindings.runAction,
        handleAction: bindings.handleAction,
        clearHistory: bindings.clearHistory,
        copyResult: bindings.copyResult,
        exportFlowContext: bindings.exportFlowContext,
        exportGenerationIr: bindings.exportGenerationIr,
        setQuestionDraftInput: bindings.setQuestionDraftInput,
        submitQuestionDraft: bindings.submitQuestionDraft,
        toggleWorklog: bindings.toggleWorklog
    };
}
